import './scripts/common';
import {onFind} from "@elements/init-modules-in-scope";

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

// Todo: Add page specific JS here e.g:

import Collapse from 'bootstrap/js/dist/collapse';
onFind('[data-bs-toggle="collapse"]',function (element) {
    new Collapse(element);
});

import Popover from 'bootstrap/js/dist/popover';
onFind('[data-bs-toggle="popover"]',function (element) {
    new Popover(element);
});

import Modal from 'bootstrap/js/dist/modal';
onFind('[data-bs-toggle="modal"]',function (element) {
    new Modal(element);
});

import * as smoothScroll from '@elements/smooth-scroll';
smoothScroll.init({scrollOffset: 160, initialPosition: true});

import * as imageSlider from './scripts/image-slider';
imageSlider.init();

import * as affix from './scripts/affix-extended';
if(matchMedia('(min-width: 768px)').matches) {
    affix.init({}, {
        base:'.js-affix-desktop',
        placeholder:'.js-affix-desktop__placeholder',
        container: '.js-affix-desktop__container'
    });
}

import * as loadCart from './scripts/load-cart';
loadCart.init();

import * as numberSpinner from '@elements/number-spinner';
numberSpinner.init();

import * as merchandiseForm from './scripts/mechandise-form';
merchandiseForm.init();

import * as sliderAnimations from './scripts/slider-animations'
sliderAnimations.init()